import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';

import {
  CIPStatisticTileConfig,
  CIPStatisticTileType,
  UseCIPStatisticLogicParams,
} from '../CIPStatistic.types';

export const useCIPStatisticLogic = ({
  data,
  isDataEmpty,
  isConfigShowed,
  isConfigLoading,
}: UseCIPStatisticLogicParams) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isEmployerOrSubsidiaryLevel = useMemo(
    () =>
      type === OrganizationTypes.employer ||
      type === OrganizationTypes.company ||
      type === OrganizationTypes.subsidiary,
    [type]
  );

  const isHidden = useMemo(
    () => (isDataEmpty && !isEmployerOrSubsidiaryLevel) || !isConfigShowed || Boolean(isConfigLoading),
    [isConfigLoading, isConfigShowed, isDataEmpty, isEmployerOrSubsidiaryLevel]
  );

  const isDetailsLinkVisible = useMemo(() => type !== OrganizationTypes.system, [type]);

  const tiles = useMemo<CIPStatisticTileConfig[]>(
    () => [
      {
        type: CIPStatisticTileType.Pending,
        testId: 'pending',
        label: 'Pending',
        value: data?.pending,
      },
      {
        type: CIPStatisticTileType.Failed,
        testId: 'failed',
        label: 'Failed',
        value: data?.failed,
      },
      {
        type: CIPStatisticTileType.Total,
        testId: 'passed',
        label: 'Passed (total)',
        value: data?.passed,
      },
    ],
    [data?.failed, data?.passed, data?.pending]
  );

  return {
    tiles,
    isDetailsLinkVisible,
    isHidden,
  };
};

export default useCIPStatisticLogic;
